
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
async download () {
let param = this.queryParams
try {
this.$vux.loading.show({ text: ' 数据载入中' })
param['pageNumber'] = this.currentPage
const queryPromise = await this.$http.get('/API/TradeStat/GetTradeDownLoad'
, {params: param, responseType: 'blob'}).then((res) => {
let type = 'application/vnd.ms-excel'
let Blob = require('blob')
let blob = new Blob([res.data], {type: type})
let fileName = res.headers.filename || '统计商品目录'
if (typeof window.navigator.msSaveBlob !== 'undefined') {
window.navigator.msSaveBlob(blob, fileName)
} else {
let URL = window.URL || window.webkitURL
let objectUrl = URL.createObjectURL(blob)
console.log(objectUrl)
if (fileName) {
var a = document.createElement('a')
if (typeof a.download === 'undefined') {
window.location = objectUrl
} else {
a.href = objectUrl
a.download = fileName
document.body.appendChild(a)
a.click()
a.remove()
this.$vux.alert.show({
title: '消息提示',
content: fileName + '已下载' })
}
} else {
window.location = objectUrl
}
}
}).catch((err) => {
console.log(err)
})
this.$vux.loading.hide()
console.log(queryPromise.data)
} catch (err) {
this.$vux.loading.hide()



}
},
async downloadfiles () {
this.$vux.alert.show({
title: '消息提示',
content: '下载功能正在开发中，敬请期待！'
})
},
async first () {
this.currentPage = 1
await this.doQuery()
},
async next () {
this.currentPage--
await this.doQuery()
},
async perv () {
this.currentPage++
await this.doQuery()
},
async doQuery () {
console.log(1)
console.log(this.companynature)
console.log(2)
let param = this.queryParams
try {
this.$vux.loading.show({ text: ' 数据载入中' })
param['pageNumber'] = this.currentPage
console.log(param)
const queryPromise = await this.$http.get('/API/TradeStat/GetTradeStateList'
, {params: param})
this.queryResult = queryPromise.data
this.$vux.loading.hide()
console.log(this.queryResult.Type)
console.log(this.queryParams)
if (this.queryResult.Data.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})

}
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
this.$router.replace({name: 'TradeStateByDataQuery', params: {code: param.enumtype}})
}
},
async getTableName () {
let no = this.queryParams.enumtype
this.tableindex = no
const queryPromise = await this.$http.get('/API/TradeStat/GroupTradeByNo'
, {params: {no: no}})
this.tablename = queryPromise.data.G_NAME
if (no === '9') {
this.tablename = '进出口商品目的地/货源地总值表'
}
}
},
data () {
return {
tableindex: 1,
tablename: '',
begin_year: this.$route.params.begin_year,
end_year: this.$route.params.end_year,
year: this.$route.params.year,
keyword: this.$route.params.keyword,
begin_index: this.$route.params.begin_index,
orgincoutry: this.$route.params.orgincoutry,
end_index: this.$route.params.end_index,
dis_country: this.$route.params.dis_country,
shipmode: this.$route.params.shipmode,
customs: this.$route.params.customs,
inareadis: this.$route.params.inareadis,
checkdis: this.$route.params.checkdis,
companynature: this.$route.params.companynature,
trademode: this.$route.params.trademode,
goods: this.$route.params.goods,
unit: this.$route.params.unit,
chapter: this.$route.params.chapter,
importcountry: this.$route.params.importcountry,
exportcountry: this.$route.params.exportcountry,
chacks: this.$route.params.chacks,
country: this.$route.params.country,
yearchack: this.$route.params.yearchack,
inoutover: this.$route.params.inoutover,
chy: this.$route.params.chy,
usd: this.$route.params.usd,
eflag: this.$route.params.eflag,
iflag: this.$route.params.iflag,
ieflag: this.$route.params.ieflag,
queryResult: {Data: [], TotalPage: 0},
p_name: '',
desc: null,
currentPage: 1,
queryParams: this.$route.params
}
},
async created () {
await this.getTableName()
this.queryParams = this.$route.params
await this.doQuery()
}
}



// WEBPACK FOOTER //
// ./src/components/TradeStateByDataDetails.vue